var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGxc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.277 28.68H2V3h17.748c1.344.269 4.544 1.237 6.588 2.958 2.554 2.151 3.9 4.84 3.63 7.798-.269 2.958-.807 4.706-1.882 5.916a29.602 29.602 0 0 0-1.748 2.151l3.63 6.858h-9.143l-2.689-4.705h-6.857v4.705zm.27-12.773v-4.84h6.587c.762.18 2.286.968 2.286 2.69 0 1.72-1.524 2.15-2.286 2.15h-6.588z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGxc);
export default __webpack_public_path__ + "static/media/GXC.fff12f86cb0fbabb464b588b722ac24e.svg";
export { ForwardRef as ReactComponent };